<template>
  <div class="hello">
    <h1>Jai Shree Swaminarayan...</h1>
    <p>  .. coming Soon </p>



<a href ="https://www.rajkotgurukul.org/home/menu/mahamuni-sadguru-shri-muktanand-swami" target="_blank">https://www.rajkotgurukul.org/home/menu/mahamuni-sadguru-shri-muktanand-swami </a>

<a href ="https://www.swaminarayan.faith/articles/nand-santos/muktanand-swami" target="_blank">https://www.swaminarayan.faith/articles/nand-santos/muktanand-swami </a>

<a href ="https://www.harismruti.com/briflifeinfo/view/23" target="_blank">https://www.harismruti.com/briflifeinfo/view/23 </a>






  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
display:block;
}
</style>
